import React, { useEffect, useState } from 'react';
import OrderCard from './OrderCard';
import OrderDetailsPopup from './OrderDetailsPopup';
import NewOrderPopup from './NewOrderPopup';
import { getPlantOrders } from '../../services/plantOrderService';

function Orders() {
  const [plantOrders, setPlantOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderDetailsPopup, setShowOrderDetailsPopup] = useState(false);
  const [showNewOrderPopup, setShowNewOrderPopup] = useState(false);

  const fetchPlantOrders = () => {
    getPlantOrders()
      .then((response) => {
        console.log("Plant Orders:", response.data);
        setPlantOrders(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleViewDetails = (orderDetails) => {
    setSelectedOrder(orderDetails);
    setShowOrderDetailsPopup(true);
  };

  const handleCloseOrderDetailsPopup = () => {
    setSelectedOrder(null);
    setShowOrderDetailsPopup(false);
  };

  const handleOpenNewOrderPopup = () => {
    setShowNewOrderPopup(true);
  };

  const handleCloseNewOrderPopup = () => {
    setShowNewOrderPopup(false);
  };

  useEffect(() => {
    fetchPlantOrders();
  }, []);

  return (
    <div className="p-6 bg-gray-800 text-gray-300 rounded-lg shadow-lg">
      <h2 className="mb-4 text-2xl font-bold text-white">Your Orders</h2>

      {/* List all orders */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {plantOrders.map((order) => (
          <OrderCard key={order.order_id} order={order} onViewDetails={handleViewDetails} />
        ))}
      </div>

      <button
        className="mt-4 px-4 py-2 font-bold text-white bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 rounded-full"
        onClick={handleOpenNewOrderPopup}
      >
        Place New Order
      </button>

      {/* Order Details Popup */}
      {showOrderDetailsPopup && selectedOrder && (
        <OrderDetailsPopup
          order={selectedOrder}
          onClose={handleCloseOrderDetailsPopup}
          onDelete={fetchPlantOrders} // Refresh orders after deletion
        />
      )}

      {/* New Order Popup */}
      {showNewOrderPopup && (
        <NewOrderPopup onClose={handleCloseNewOrderPopup} onOrderCreated={fetchPlantOrders} />
      )}
    </div>
  );
}

export default Orders;
